


























import { NotificationAssoc } from '@/utils/NotificationUtils';
import mixins from 'vue-typed-mixins';
import moment from 'moment';
import TileUtils from '@/utils/TileUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => NotificationAssoc,
    },
  },

  computed: {
    datepublished(): string {
      return moment(this.value?.notification?.datepublished).format(
        'YYYY-MM-DD'
      );
    },
  },

  data(): {
    visible: boolean;
  } {
    return {
      visible: false,
    };
  },

  methods: {
    async markAsRead(item: NotificationAssoc) {
      try {
        this.$alert.hide('load');
        await TileUtils.markNotificationAsRead(item.notification?.id as number);
        this.value.read = true;
        this.visible = false;
      } catch (error) {
        this.$alert.show('load', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
